import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'
import { FormattedMessage } from 'react-intl'
import onClickOutside from 'react-onclickoutside'
import { uncontrollable } from 'uncontrollable'
import scrollIntoView from 'scroll-into-view-if-needed'
import Form from './Form'
import classes from './Editable.module.scss'

export class Editable extends React.Component {
  static propTypes = {
    disableOnClickOutside: PropTypes.func.isRequired,
    enableOnClickOutside: PropTypes.func.isRequired,

    unsavedValue: PropTypes.string,

    addUnsavedChange: PropTypes.func.isRequired,
    removeUnsavedChange: PropTypes.func.isRequired,

    editing: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    textarea: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.bool
    ]),
    buttons: PropTypes.func,
    form: PropTypes.string,
    saveChanges: PropTypes.bool,
    validate: PropTypes.func,
    initialValues: PropTypes.object,
    onClickOutside: PropTypes.func,
    maxLength: PropTypes.number,
    rootClose: PropTypes.bool,
    submitOnEnter: PropTypes.bool,
    className: PropTypes.string,
    onEditToggle: PropTypes.func.isRequired,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
  }

  static defaultProps = {
    editing: false,
    form: 'editable',
    saveChanges: false,
    rootClose: true
  }

  constructor (props) {
    super(props)

    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.handleDiscardClick = this.handleDiscardClick.bind(this)
  }

  componentDidMount () {
    if (this.props.editing) {
      this.scrollIntoView()
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.editing && !prevProps.editing) {
      this.scrollIntoView()
    }
  }

  componentWillUnmount () {
    cancelAnimationFrame(this.requestedFrame)
  }

  scrollIntoView = () => {
    cancelAnimationFrame(this.requestedFrame)
    this.requestedFrame = requestAnimationFrame(() => {
      scrollIntoView(findDOMNode(this), {
        scrollMode: 'if-needed',
        block: 'nearest'
      })
    })
  }

  handleClickOutside (evt) {
    const { rootClose } = this.props

    if (rootClose) {
      this.close()
    }
  }

  open (event) {
    if (!this.props.editing) {

      this.props.onEditToggle(true)
      if (this.props.onOpen) this.props.onOpen(this)
    }
  }

  close () {
    if (this.props.editing) {
      this.props.onEditToggle(false)
      if (this.props.onClose) this.props.onClose(this)
    }
  }

  handleClick (event) {
    event.stopPropagation()
  }

  handleFormSubmit (...args) {
    const { form, onSubmit, removeUnsavedChange } = this.props

    this.close()

    removeUnsavedChange({
      id: form
    })

    return onSubmit(...args)
  }

  handleDiscardClick (event) {
    const { form, removeUnsavedChange } = this.props

    event.preventDefault()

    removeUnsavedChange({
      id: form
    })
  }

  render () {
    const {
      children,

      disableOnClickOutside, // eslint-disable-line no-unused-vars
      enableOnClickOutside, // eslint-disable-line no-unused-vars

      unsavedValue,

      addUnsavedChange,
      removeUnsavedChange,

      editing,
      onSubmit, // eslint-disable-line no-unused-vars
      textarea,
      buttons,
      form,
      saveChanges,
      validate,
      initialValues,
      onClickOutside, // eslint-disable-line no-unused-vars
      maxLength,
      rootClose, // eslint-disable-line no-unused-vars
      submitOnEnter,
      className,
      onOpen, // eslint-disable-line no-unused-vars
      onClose, // eslint-disable-line no-unused-vars

      ...props
    } = this.props

    let compClassName = classes.editable
    if (className) compClassName += ' ' + className

    const buttonsWithArgs = () => buttons ? buttons(this) : null

    const _initialValues =
      (saveChanges && unsavedValue)
      ? {
        name: unsavedValue
      }
      : initialValues

    return (
      <span
        {...props}
        onClick={this.handleClick}
        className={compClassName}
      >
        {editing &&
          <Form
            textarea={textarea}
            form={form}
            saveChanges={saveChanges}
            unsavedValue={unsavedValue}
            initialValue={initialValues.name || ''}
            initialValues={_initialValues}
            validate={validate}
            buttons={buttonsWithArgs}
            onSubmit={this.handleFormSubmit}
            onCancel={this.close}
            maxLength={maxLength}
            submitOnEnter={submitOnEnter}
            addUnsavedChange={addUnsavedChange}
            removeUnsavedChange={removeUnsavedChange}
          />
        }
        {!editing &&
          <span
            onClick={this.open}
            className={classes.childrenWrapper}
          >
            {children}
          </span>
        }
        {(!editing && saveChanges && unsavedValue) &&
          <span className={classes.unsavedChanges}>
            <span
              className={'c-orange ' + classes.unsavedChangesInfo}
              onClick={this.open}
            >
              <FormattedMessage id='UNSAVED_CHANGES_INFO' />
            </span>
            <a
              href='#'
              onClick={this.handleDiscardClick}
            >
              <FormattedMessage id='UNSAVED_CHANGES_DISCARD' />
            </a>
          </span>
        }
      </span>
    )
  }
}

export default uncontrollable(
  onClickOutside(Editable),
  {
    editing: 'onEditToggle'
  }
)
